import { Sucursal } from './sucursal.model';

export class BranchRelation {

constructor(public idSucursal: number, public sucursal: Sucursal){}

}
